import { API_HOST } from './config'
export default {
  // ADMIN ROUTES
  ADMIN_INQUIRIES: `${API_HOST}admin/inquiries/all_inquiries`,
  ADMIN_REPLY_INQUIRIES: `${API_HOST}admin/inquiries/reply`,
  ADMIN_DELETE_INQUIRIES: `${API_HOST}admin/inquiries/delete_inquiries`,
  ADMIN_READ_INQUIRIES: `${API_HOST}admin/inquiries/read_all_inquiries`
}